<template>
  <b-modal
    v-model="editorShown"
    title="Autofill"
    @hidden="onHidden"
    @ok="submitAutofill"
    centered
    size="md"
    no-close-on-backdrop
    header-bg-variant="primary"
    header-text-variant="white"
    header-class="bg-purple"
  >
    <template v-slot:modal-footer>
      <div class="text-right mt-1 mr-2">
        <b-button @click="$emit('onModify')" variant="secondary"
          >Cancel</b-button
        >
        <b-button class="ml-2" @click="submitAutofill" variant="primary"
          >Save</b-button
        >
      </div>
    </template>
    <b-form-group
      label="Amount of days"
      :state="formErrors.days.length == 0 ? null : false"
      :invalid-feedback="formErrors.days.join(', ')"
    >
      <b-form-input
        placeholder=""
        v-model="form.days"
        type="number"
        :max="form.remainingDays"
        trim
        :errors="formErrors.days"
      ></b-form-input>
    </b-form-group>
    <b-form-group
      label="Starting on"
      :state="formErrors.startingOn.length == 0 ? null : false"
      :invalid-feedback="formErrors.startingOn.join(', ')"
    >
      <date-picker
        v-model="form.startingOn"
        :errors="formErrors.startingOn"
        :min="form.startDate"
        :max="form.endDate"
      ></date-picker>
    </b-form-group>
    <b-form-checkbox v-model="form.excludeWeekends">
      Exclude Weekends
    </b-form-checkbox>
  </b-modal>
</template>

<script>
import moment from "moment";
import { mapActions } from "vuex";
import DatePicker from "../controls/DatePicker";
import { validateDate, validateRequired } from "../../helpers/validation";
import { formatDateOnlyMysql } from "../../helpers/date";
import urRecordServer from "../../server/urRecord";
import scheduleEventServer from "../../server/scheduleEvent";

export default {
  name: "EocViewCalendarUtilizationAutofillModal",
  components: { DatePicker },
  props: ["eocId", "urId"],
  data() {
    return {
      submit: null,
      form: {
        levelOfCare: null,
        startDate: null,
        endDate: null,
        remainingDays: 4,
        days: 0,
        startingOn: null,
        excludeWeekends: false
      },
      formErrors: {
        days: [],
        startingOn: []
      },
      ur: null
    };
  },
  async mounted() {
    this.fetchUr();
  },
  methods: {
    ...mapActions("layout", ["showAlertSuccess"]),
    onHidden() {},
    validateSubmitAutofill() {
      let withoutErrors = true;

      this.formErrors.startingOn = [];
      if (!validateRequired(this.form.startingOn)) {
        this.formErrors.startingOn.push("This field is required");
        withoutErrors = false;
      }
      if (this.form.startingOn && !validateDate(this.form.startingOn)) {
        this.formErrors.startingOn.push(
          "This field must have a valid date format"
        );
        withoutErrors = false;
      }

      this.formErrors.days = [];
      if (!validateRequired(this.form.days)) {
        this.formErrors.days.push("This field is required");
        withoutErrors = false;
      }
      if (
        this.form.days &&
        parseInt(this.form.days) > this.form.remainingDays
      ) {
        this.formErrors.days.push(
          "There is only " + this.form.remainingDays + " days remaining"
        );
        withoutErrors = false;
      }

      return withoutErrors;
    },
    async submitAutofill(modalEvent) {
      modalEvent.preventDefault();
      const result = this.validateSubmitAutofill();
      if (result) {
        const dates = [];
        let currentDate = this.form.startingOn;
        while (
          dates.length < this.form.days &&
          currentDate <= this.form.endDate &&
          currentDate >= this.form.startDate
        ) {
          const day = moment(currentDate)
            .toDate()
            .getDay();
          const isWeekend = day === 6 || day === 0;
          if (!this.form.excludeWeekends || !isWeekend) {
            dates.push(currentDate);
          }
          currentDate = formatDateOnlyMysql(
            moment(currentDate)
              .add(1, "day")
              .toDate()
          );
        }
        await scheduleEventServer.createMultiple({
          episodeOfCareId: this.eocId,
          levelOfCareId: this.ur.service.id,
          day: null,
          days: dates
        });
        this.showAlertSuccess();
        this.$emit("onModify");
      }
    },
    async fetchUr() {
      this.ur = await urRecordServer.get(this.urId);
      this.form.startDate = this.ur.startDate;
      this.form.endDate = this.ur.endDate;
      this.form.remainingDays = this.ur.remainingUnits;
      this.form.days = this.ur.remainingUnits;
    }
  },
  computed: {
    editorShown: {
      get() {
        return !!this.$attrs.value;
      },
      set(value) {
        this.$emit("input", value);
      }
    }
  }
};
</script>
